export const CommonReducerKey = 'CommonReducer';
export const SettingReducerKey = 'SettingReducer';